module.exports = __webpack_public_path__ + "img/Comic04-4.015f3033.png";